import type { FunctionComponent, MouseEvent } from 'react';
import _get from 'lodash/get';

import { Column } from '../models';

import MuiTableRow from '@mui/material/TableRow';
import ActionTableCheckbox from '../action-table-checkbox';
import { TableCell } from '../styled';

import styled from 'shared/utils/styled';
import { useStyles } from './style';

const StyledTableRow = styled(MuiTableRow)(({ onClick }) => ({
  ...(!!onClick && {
    '&:hover': {
      background: 'rgb(247, 247, 247)',
      cursor: 'pointer',
    },
  }),
}));

interface ActionTableRowProps<
  Data extends Record<string, any> = any,
  Component extends FunctionComponent = typeof ActionTableCheckbox
> {
  data: Data;
  columns: Column<Data>[];
  withCheckbox: boolean;
  CheckboxComponent: Component;
  CheckboxComponentProps: Component['defaultProps'];
  onClick?: (event: MouseEvent<HTMLTableRowElement>) => void;
}

const ActionTableRow: React.FC<ActionTableRowProps> = (props) => {
  const classes = useStyles();

  const {
    data,
    columns,
    CheckboxComponent,
    CheckboxComponentProps,
    withCheckbox,
    onClick,
  } = props;

  return (
    <StyledTableRow className={classes.row} onClick={onClick}>
      {withCheckbox && (
        <TableCell>
          <CheckboxComponent
            onClick={(event) => {
              event.stopPropagation();
            }}
            {...CheckboxComponentProps}
          />
        </TableCell>
      )}
      {columns.map((column) => {
        const renderData = column.render
          ? column.render(data)
          : _get(data, column.accessor, null);

        return (
          <TableCell key={column.accessor as string}>{renderData}</TableCell>
        );
      })}
    </StyledTableRow>
  );
};

export default ActionTableRow;
